export enum ProjectBlockerStatus {
  SELLER_ACTION_NEEDED = "seller_action_needed",
  HOMEOWNER_ACTION_NEEDED = "homeowner_action_needed",
  PENDING_REVIEW = "pending_review",
  IN_REVIEW = "in_review",
  PENDING = "pending",
  PENDING_CORRECTIONS = "pending_corrections",
  COMPLETE = "complete",
  DEFERRED = "deferred",
}

export enum ProjectBlockerReason {
  OS = "os",
  BUILDABLE_WITH_CHANGES = "buildable_with_changes",
  CHANGE_ORDER_REQUIRED = "change_order_required",
  MISSING_HAND_OFF_NOTES = "missing_hand_off_notes",
}

export enum ProjectBlockerAssetType {
  BLOCKER = "blocker",
  OS = "os",
}

export enum ProjectBlockerKind {
  INTAKE = "intake",
  SOW = "sow",
  UNCATEGORIZED = "uncategorized",
}
